
import Button from '@/components/NewUiElements/Buttons/Button'
export default {
    name: 'RenameNodeModal',
    components: { Button },
    props: {
        value: {
            type: null,
            default: ''
        },
        node: {
            type: Object,
            required: true
        },
        error: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            name: this.node.name
        }
    },
    watch: {
        name: {
            handler () {
                this.$emit('input', this.name)
            },
            immediate: true
        }
    },
    mounted () {
        this.$refs.name.focus()
    },
    methods: {
        rename () {
            this.$emit('rename-node', { node: this.node, name: this.name })
        }
    }
}
